import Parse from "./parse.service";

export const sendWelcomeMessage = async (name, phone) => {
    const params = { name, phone };
    try {
        const result = await Parse.Cloud.run("sendWelcomeMessage", params);
        return result;
    } catch (err) {
        return err;
    }
};